export function fmtCurrency(v) {
  if (v === "" || v === null || v === undefined || isNaN(Number(v))) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(
    Number(v)
  );
}

export function fmtNumber(v) {
  if (v === "" || v === null || v === undefined || isNaN(Number(v))) return "—";
  return new Intl.NumberFormat("en-US").format(Number(v));
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export function fmtDate(s) {
  if (!s) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(s + "T00:00:00") : new Date(s);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

// Convert common date strings (M/D/YYYY, M/D/YY, "Jun 1, 2026") to ISO YYYY-MM-DD for <input type="date">.
export function toISODate(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (m) {
    let [, mo, da, yr] = m;
    if (yr.length === 2) yr = "20" + yr;
    return `${yr}-${String(mo).padStart(2, "0")}-${String(da).padStart(2, "0")}`;
  }
  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  return s;
}
